import { render, staticRenderFns } from "./HistoryPeriod.vue?vue&type=template&id=fa124b12&scoped=true&"
import script from "./HistoryPeriod.vue?vue&type=script&lang=js&"
export * from "./HistoryPeriod.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPeriod.vue?vue&type=style&index=0&id=fa124b12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa124b12",
  null
  
)

export default component.exports